export default {
  info: {
    en: 'Info',
  },
}
